import * as React from 'react';

import * as styles from './NewbuildingInfo.css';

interface INewbuildingInfoProps {
  title: React.ReactNode;
  description: React.ReactNode;
}

export const NewbuildingInfo = ({ title, description }: INewbuildingInfoProps) => {
  return (
    <div data-testid="newbuildingInfo">
      <div className={styles['title']} data-testid="newbuildingTitle">
        {title}
      </div>
      <div className={styles['description']} data-testid="newbuildingMainFacts">
        {description}
      </div>
    </div>
  );
};
